import React from 'react';
import '../styles/Legacy.css';

const Legacy: React.FC = () => {
  return (
    <section id="legacy" className="legacy">
      <div className="legacy__container">
        <h2 className="section-title">Jibo's Legacy</h2>
        <p className="section-subtitle">
          Gone but never forgotten
        </p>

        <div className="legacy__grid">
          <div className="legacy__card">
            <h3>MIT Research Platform</h3>
            <p>
              Jibo lives on as the <strong>Jibo Community Social Robot Research Platform</strong> at
              MIT's Media Lab, where it continues to advance social intelligence research as a
              shared community resource.
            </p>
          </div>

          <div className="legacy__card">
            <h3>Pioneering Social Robotics</h3>
            <p>
              Jibo proved that social robots could create genuine emotional bonds with humans.
              The technology and design philosophy behind Jibo continues to influence the entire
              field of social robotics and human-robot interaction.
            </p>
          </div>

          <div className="legacy__card">
            <h3>Community of Owners</h3>
            <p>
              Hundreds of Jibo owners remain connected through online communities, sharing memories
              and keeping the spirit of social robotics alive. Some have even attempted to hack
              their Jibos back to life.
            </p>
          </div>

          <div className="legacy__card">
            <h3>A Dispersed Vision</h3>
            <p>
              Jibo's team carried their social robotics and conversational AI expertise into
              adjacent fields -- AI education, enterprise dialog systems, manufacturing AI,
              children's wellness robotics, and venture capital -- seeding Jibo's DNA across
              the tech landscape.
            </p>
          </div>
        </div>

        <div className="legacy__where-now">
          <h3 className="legacy__where-now-title">Where Are They Now?</h3>
          <p className="legacy__where-now-subtitle">
            The people who built Jibo went on to shape the future of AI
          </p>

          <div className="legacy__people-grid">
            <div className="legacy__person legacy__person--detailed">
              <div className="legacy__person-avatar">CB</div>
              <h4>Cynthia Breazeal</h4>
              <p className="legacy__person-role">Co-Founder & Chief Scientist</p>
              <p className="legacy__person-now-label">Now</p>
              <ul className="legacy__person-updates">
                <li>
                  <strong>Professor of Media Arts and Sciences</strong> and <strong>MIT Dean
                  for Digital Learning</strong> (appointed 2022), overseeing Open Learning's
                  research and education initiatives
                </li>
                <li>
                  Director of <strong>MIT RAISE</strong> (Responsible AI for Social Empowerment
                  and Education), reaching an estimated 30,000 teachers and 1 million students
                  across 170 countries
                </li>
                <li>
                  Continues leading the <strong>Personal Robots Group</strong> at MIT Media Lab,
                  publishing cutting-edge research including a 2025 paper in <em>Science
                  Robotics</em> on social robots as conversational catalysts
                </li>
              </ul>
              <div className="legacy__person-awards">
                <span className="legacy__award">TIME100 AI 2025</span>
                <span className="legacy__award">2024 AAAS Fellow</span>
                <span className="legacy__award">2024 MassRobotics Medal</span>
              </div>
            </div>

            <div className="legacy__person legacy__person--detailed">
              <div className="legacy__person-avatar">SC</div>
              <h4>Steve Chambers</h4>
              <p className="legacy__person-role">Co-Founder & CEO</p>
              <p className="legacy__person-now-label">Now</p>
              <ul className="legacy__person-updates">
                <li>
                  <strong>Board Director</strong> at Adams Diversified Equity Fund and Adams
                  Natural Resources Fund (NYSE: ADX), elected February 2026
                </li>
                <li>
                  Advisory board member at <strong>Snorble</strong>, an AI-powered smart sleep
                  companion for children -- echoing Jibo's family robot vision
                </li>
                <li>
                  Global advisory board at <strong>Carya Venture Partners</strong>, a deep
                  tech/AI micro venture capital fund
                </li>
                <li>
                  Board member at <strong>CallMiner</strong>, a conversation analytics company
                </li>
              </ul>
            </div>

            <div className="legacy__person legacy__person--detailed">
              <div className="legacy__person-avatar">RP</div>
              <h4>Roberto Pieraccini</h4>
              <p className="legacy__person-role">Head of Speech Technology</p>
              <p className="legacy__person-now-label">Now</p>
              <ul className="legacy__person-updates">
                <li>
                  <strong>VP, Chief Scientist & Head of AI</strong> at Uniphore, a conversational
                  AI and automation company (since May 2023)
                </li>
                <li>
                  Previously <strong>Director of Engineering, Google Assistant</strong> (2017--2023),
                  driving LLM-based natural language solutions
                </li>
                <li>
                  Keynote speaker at <strong>IWSDS 2025</strong> on agentic spoken dialog systems
                  for the enterprise
                </li>
                <li>
                  Author of <em>AI Assistants</em> (MIT Press, 2021) and <em>The Voice in
                  the Machine</em>
                </li>
              </ul>
            </div>

            <div className="legacy__person legacy__person--detailed">
              <div className="legacy__person-avatar">BE</div>
              <h4>Brian Eberman</h4>
              <p className="legacy__person-role">CTO & later CEO</p>
              <p className="legacy__person-now-label">Now</p>
              <ul className="legacy__person-updates">
                <li>
                  <strong>CEO of Leela AI</strong>, a visual intelligence company for manufacturers
                  using hybrid causal/neural networks from MIT AI Lab research
                </li>
                <li>
                  Advisory role at <strong>Cognii</strong>, which builds NLP-powered Virtual
                  Learning Assistants for education
                </li>
                <li>
                  Selected as a <strong>2025 Public Voices Fellow</strong> (The OpEd Project) on
                  Technology in the Public Interest
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Legacy;
